"use strict";

export default (useTreeTabMode = false) => {

    if (!useTreeTabMode) {
        return `<th data-sort-method="text" class="number no_bold align_right"></th>` +
            `<th data-sort-method="number" class="number no_bold align_right bleft-white c7tv">000s</th>` +
            `<th data-sort-method="number" class="percentage no_bold align_right c7tv">%</th>` +
            `<th data-sort-method="number" class="percentage no_bold align_right c7tv">%</th>` +
            `<th data-sort-method="time" class="minutage no_bold align_right c7tv">MM:SS</th>` +
            `<th data-sort-method="number" class="number no_bold align_right bleft-white ttsv">000s</th>` +
            `<th data-sort-method="number" class="percentage no_bold align_right ttsv">%</th>` +
            `<th data-sort-method="number" class="percentage no_bold align_right ttsv">%</th>` +
            `<th data-sort-method="time" class="minutage no_bold align_right ttsv">MM:SS</th>`;
    } else {
        return `<th data-sort-method="text" class="number no_bold align_right"></th>` +
            `<th data-sort-method="number" class="number no_bold align_right bleft-white tbv">000s</th>` +
            `<th data-sort-method="number" class="percentage no_bold align_right tbv">%</th>` +
            `<th data-sort-method="number" class="percentage no_bold align_right tbv">%</th>` +
            `<th data-sort-method="time" class="minutage no_bold align_right tbv">MM:SS</th>` +
            `<th data-sort-method="number" class="number no_bold align_right bleft-white tiv">000s</th>` +
            `<th data-sort-method="number" class="percentage no_bold align_right tiv">%</th>` +
            `<th data-sort-method="number" class="percentage no_bold align_right tiv">%</th>` +
            `<th data-sort-method="time" class="minutage no_bold align_right tiv">MM:SS</th>` +
            `<th data-sort-method="number" class="number no_bold align_right bleft-white tsv">000s</th>` +
            `<th data-sort-method="number" class="percentage no_bold align_right tsv">%</th>` +
            `<th data-sort-method="number" class="percentage no_bold align_right tsv">%</th>` +
            `<th data-sort-method="time" class="minutage no_bold align_right tsv">MM:SS</th>`
    }
}